module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4",
      "offset-sm": "4"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Login")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Email",
      "id": "email",
      "required": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login()
      }
    },
    model: {
      value: (_vm.credentials.username),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "username", $$v)
      },
      expression: "credentials.username"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Password",
      "id": "password",
      "type": "password",
      "required": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login()
      }
    },
    model: {
      value: (_vm.credentials.password),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "password", $$v)
      },
      expression: "credentials.password"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'passwordResetRequest'
      }
    }
  }, [_vm._v("Forgot My Password")])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.login.apply(null, arguments)
      }
    }
  }, [_vm._v("Login")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('error-snackbar', {
    model: {
      value: (_vm.errorText),
      callback: function($$v) {
        _vm.errorText = $$v
      },
      expression: "errorText"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-034b536d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 385
// module chunks = 1